export default {"src":"/_next/static/media/money_24.087dc11a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};